export const SCOPE_3_CATEGORIES_KEYS = Object.freeze({
  categoryOne: "categoryOne",
  categoryTwo: "categoryTwo",
  categoryThree: "categoryThree",
  categoryFour: "categoryFour",
  categoryFive: "categoryFive",
  categorySix: "categorySix",
  categorySeven: "categorySeven",
  categoryEight: "categoryEight",
  categoryNine: "categoryNine",
  categoryTen: "categoryTen",
  categoryEleven: "categoryEleven",
  categoryTwelve: "categoryTwelve",
  categoryThirteen: "categoryThirteen",
  categoryFourteen: "categoryFourteen",
  categoryFifteen: "categoryFifteen",
});

export const SCOPE_3_CATEGORIES_STEPS = [
  SCOPE_3_CATEGORIES_KEYS.categoryOne,
  SCOPE_3_CATEGORIES_KEYS.categoryTwo,
  SCOPE_3_CATEGORIES_KEYS.categoryThree,
  SCOPE_3_CATEGORIES_KEYS.categoryFour,
  SCOPE_3_CATEGORIES_KEYS.categoryFive,
  SCOPE_3_CATEGORIES_KEYS.categorySix,
  SCOPE_3_CATEGORIES_KEYS.categorySeven,
  SCOPE_3_CATEGORIES_KEYS.categoryEight,
  SCOPE_3_CATEGORIES_KEYS.categoryNine,
  SCOPE_3_CATEGORIES_KEYS.categoryTen,
  SCOPE_3_CATEGORIES_KEYS.categoryEleven,
  SCOPE_3_CATEGORIES_KEYS.categoryTwelve,
  SCOPE_3_CATEGORIES_KEYS.categoryThirteen,
  SCOPE_3_CATEGORIES_KEYS.categoryFourteen,
  SCOPE_3_CATEGORIES_KEYS.categoryFifteen
];
